import { useDeleteMutation } from "@/api/swr/useMutation";
import { z } from "zod";

type Config = Parameters<
  typeof useDeleteMutation<z.ZodUndefined, z.ZodNull>
>[3];

export const useDeleteAssessor = (id: number, config?: Config) => {
  return useDeleteMutation(
    z.undefined(),
    z.null(),
    `/console/admin_users/${id}`,
    config,
  );
};
